export * from '../overrides/toggable-group';

// soon to be depricated.
import { ToggableGroup } from '../overrides/toggable-group';

export default ToggableGroup
